export function invalidateQuery({ queryClient, queryKey, filters, id }) {
  if (filters) {
    queryClient.invalidateQueries({
      queryKey: [queryKey, JSON.stringify(filters)],
    });
    return;
  }

  if (id) {
    queryClient.invalidateQueries({
      queryKey: [queryKey, id],
    });
    return;
  }

  queryClient.invalidateQueries({
    queryKey: [queryKey],
    exact: false,
  });
}
